import { ModalTitle } from '@strava/ui/Modal';
import React, { useEffect } from 'react';
import PERMISSION_TYPES from '../../../../../../constants/consents/permissionTypes';
import { CONSENTS_FLOW } from '../../../../shared/onboardingConstants';
import { analyticsPageName, t } from '../../../../shared/onboardingUtils';
import useNavigateToNextStep from '../../../../shared/useNavigateToNextStep';
import { useOnboardingContext } from '../../../../state/OnboardingContext';
import ActionButton, { ACTIONS } from '../../../ActionButton/ActionButton';
import ModalBodyWithAlerts from '../../../ModalBodyWithAlerts';
import OnboardingLinkButton from '../../../OnboardingLinkButton';
import OnboardingModalActions from '../../../OnboardingModalActions';
import OnboardingUL from '../../../OnboardingUL/OnboardingUL';
import styles from './TermsOfService.scss';

const TermsOfService = () => {
  const { state, dispatch, track } = useOnboardingContext();
  const { stepForward, isProcessing } = useNavigateToNextStep({
    state,
    dispatch,
    track
  });
  const { alert } = state;

  useEffect(() => {
    track({
      page: analyticsPageName(CONSENTS_FLOW.termsOfService),
      action: 'screen_enter'
    });
  }, [track]);

  const tosList = (() => {
    const result = [];
    for (let index = 1; index <= 8; index++) {
      result.push(
        <li key={`li-${index}`}>{t(`consents.tos.list.li_${index}`)}</li>
      );
    }
    return result;
  })();

  return (
    <>
      <ModalTitle id="onboarding-step-title">
        {t('consents.tos.title')}
      </ModalTitle>
      <ModalBodyWithAlerts className={styles.modal} alert={alert}>
        <p>{t('consents.tos.p_1')}</p>
        <OnboardingUL>{tosList}</OnboardingUL>
        <OnboardingLinkButton href="/legal/terms">
          {t('consents.tos.see_full_tos')}
        </OnboardingLinkButton>
      </ModalBodyWithAlerts>

      <OnboardingModalActions className={styles.modalActions}>
        <p>{t('consents.tos.p_2')}</p>
        <ActionButton
          variant="primary"
          onClick={() =>
            stepForward({
              action: ACTIONS.approved,
              permissionType: PERMISSION_TYPES.termsOfService
            })
          }
          data-cy="terms-of-service-next-step-btn"
          isProcessing={isProcessing}
          focus={true}
        >
          {t('cta_actions.continue')}
        </ActionButton>
      </OnboardingModalActions>
    </>
  );
};

export default TermsOfService;
